import { PropsWithChildren } from 'react';
import styles from './style.module.scss';
import { joinNames } from '../helpers';
type SpinnerProps = { text?: string; className?: string } & PropsWithChildren;
export default function Spinner({ text = 'Loading...', className, children }: SpinnerProps) {
    return (
        <div className={joinNames(styles.root, className)}>
            <div className={styles.loader}></div>
            <div className={styles.text}>{text}</div>
            {children && <div className={styles.text}>{children}</div>}
        </div>
    );
}
